// Checking the player's pencil marks as they go (Settings: "Check pencil marks"), fogged cells
// included (Marko, 2026-11-01). A mark is red only when its digit is placed in the same row,
// column or region: the solution is never used for marks, at any level, so they can't give a
// cell's digit away (Marko, 2026-11-04: "only clashes"; before, at Solution, a cell's marks all
// turned red once they left out its digit, which told a fogged cell's digit).
import type { MistakeChecking } from '@zinc/shared';
import { values, type GridState } from './game';
import type { Geometry } from './geometry';

/** Per cell, the marks to show in red. */
export interface WrongMarks {
  corner: Map<number, Set<string>>;
  centre: Map<number, Set<string>>;
  position: Map<number, Set<string>>;
}

export const NO_WRONG_MARKS: WrongMarks = {
  corner: new Map(),
  centre: new Map(),
  position: new Map(),
};

function flag(into: Map<number, Set<string>>, cell: number, digit: string) {
  let set = into.get(cell);
  if (!set) into.set(cell, (set = new Set()));
  set.add(digit);
}

/** The marks that clash with a placed digit (given or entered) in the same row, column or
 * region; nothing when mistake checking is off. */
export function wrongMarks(g: Geometry, s: GridState, level: MistakeChecking): WrongMarks {
  if (level === 'off') return NO_WRONG_MARKS;
  const out: WrongMarks = { corner: new Map(), centre: new Map(), position: new Map() };
  const vals = values(g, s);
  s.cells.forEach((cell, i) => {
    if (vals[i] !== null) return;
    for (const key of ['corner', 'centre', 'position'] as const) {
      for (const d of cell[key]) {
        if (g.peers[i]!.some((p) => vals[p] === d)) flag(out[key], i, d);
      }
    }
  });
  return out;
}
